export default __webpack_public_path__ + "static/media/BluePlus.d33644a0.svg";